import { useEffect } from 'react';
import type { FormEventName } from './types';

function isAllowedFormOrigin(origin: string): boolean {
  try {
    const { hostname } = new URL(origin);
    return (
      hostname === window.location.hostname ||
      hostname.endsWith('.hsforms.net') ||
      hostname.endsWith('.hsformsqa.net')
    );
  } catch {
    return false;
  }
}

export function useFormMessageEvents(
  formId: string,
  dispatch: (eventName: FormEventName) => void
) {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!isAllowedFormOrigin(event.origin)) return;
      if (typeof event.data !== 'object' || event.data === null) return;

      const { type, id, eventName } = event.data as {
        type: string;
        id: string;
        eventName: string;
      };

      if (type === 'hsFormCallback' && id === formId) {
        dispatch(eventName as FormEventName);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [formId, dispatch]);
}
